// ./src/components/PasswordPrompt.js
import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import api from '../api/api';

const PasswordPrompt = ({ onPasswordVerified }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const theme = useTheme();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/api/chat/verify-password`, { password });
            if (response.data.success) {
                onPasswordVerified();
            } else {
                setError('Incorrect password. Please try again.');
            }
        } catch (err) {
            setError('Incorrect password. Please try again.');
        }
    };

    return (
        <Box
        >
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <TextField
                    type="password"
                    label="Enter Password"
                    variant="outlined"
                    fullWidth
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setError('');
                    }}
                />
                {error && (
                    <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                        {error}
                    </Typography>
                )}
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                    Submit
                </Button>
            </form>
        </Box>
    );
};

export default PasswordPrompt;
